<template>
  <div>
    <mf-action-buttons
      v-if="newCampaign && !franchise"
      :primary-button="{
        text: 'Ativar banner',
        action: saveActive,
        isVisible: true,
        isLoading: loading.saveActive,
        isDisabled: anyLoading && !loading.saveActive,
      }"
      :secondary-button="{
        text: 'Salvar rascunho',
        action: saveDraft,
        isVisible: true,
        isLoading: loading.saveDraft,
        isDisabled: anyLoading && !loading.saveDraft,
      }"
      :cancel-button="{
        text: 'Cancelar',
        action: redirectBanners,
        isVisible: true,
      }"
    />

    <mf-action-buttons
      v-else-if="scheduledCampaign && !franchise"
      :primary-button="{
        text: 'Salvar alterações',
        action: saveActive,
        isVisible: true,
        isLoading: loading.saveActive,
        isDisabled: anyLoading && !loading.saveActive,
      }"
      :secondary-button="{
        text: 'Desativar',
        action: disableDraft,
        isVisible: true,
        isLoading: loading.disableDraft,
        isDisabled: anyLoading && !loading.saveDraft,
      }"
      :cancel-button="{
        text: 'Cancelar',
        action: redirectBanners,
        isVisible: true,
      }"
    />

    <mf-action-buttons
      v-else-if="finishedCampaign && !franchise"
      :primary-button="{
        text: 'Duplicar',
        action: clone,
        isVisible: true,
        isLoading: loading.clone,
        isDisabled: anyLoading && !loading.clone,
      }"
      :cancel-button="{
        text: 'Cancelar',
        action: redirectBanners,
        isVisible: true,
      }"
    />

    <mf-action-buttons
      v-else-if="draftCampaign && !franchise"
      :primary-button="{
        text: 'Ativar banner',
        action: saveActive,
        isVisible: true,
        isLoading: loading.saveActive,
        isDisabled: anyLoading && !loading.saveActive,
      }"
      :secondary-button="{
        text: 'Salvar alterações',
        action: saveDraft,
        isVisible: true,
        isLoading: loading.saveDraft,
        isDisabled: anyLoading && !loading.saveDraft,
      }"
      :extra-button="{
        text: 'Apagar rascunho',
        action: deleteCampaign,
        isVisible: true,
        isLoading: loading.deleteCampaign,
        isDisabled: anyLoading && !loading.deleteCampaign,
      }"
      :cancel-button="{
        text: 'Cancelar',
        action: redirectBanners,
        isVisible: true,
      }"
    />

    <mf-action-buttons
      v-else-if="activeCampaign && !franchise"
      :primary-button="{
        text: 'Salvar alterações',
        action: saveActive,
        isVisible: true,
        isLoading: loading.saveDraft,
        isDisabled: anyLoading && !loading.saveDraft,
      }"
      :secondary-button="{
        text: 'Finalizar',
        action: finalizeCommercial,
        isVisible: true,
        isLoading: loading.saveActive,
        isDisabled: anyLoading && !loading.saveActive,
      }"
      :cancel-button="{
        text: 'Cancelar',
        action: redirectBanners,
        isVisible: true,
      }"
    />

    <mf-action-buttons
      v-else-if="franchise"
      :primary-button="{
        text: 'Fechar',
        action: redirectBanners,
        isVisible: true,
      }"
    />
  </div>
</template>

<script>
import { MUTATION_UNSCHEDULED_COMMERCIAL, MUTATION_FINALIZE_COMMERCIAL, MUTATION_CLONE_COMMERCIAL, MUTATION_DELETE_COMMERCIAL } from '../../graphql'

export default {
  props: {
    object: Object,
    mode: String,
    save: Function,
    franchise: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    loading: {
      saveDraft: false,
      saveActive: false,
      clone: false,
      deleteCampaign: false,
    },
  }),
  computed: {
    newCampaign() {
      return !this.object._id
    },
    activeCampaign() {
      return ['ACTIVE'].includes(this.object.status)
    },
    finishedCampaign() {
      return ['FINISHED'].includes(this.object.status)
    },
    draftCampaign() {
      return ['DRAFT'].includes(this.object.status)
    },
    scheduledCampaign() {
      return ['SCHEDULED'].includes(this.object.status)
    },
    anyLoading() {
      return Object.entries(this.loading).some(([key, value]) => value)
    },
  },
  methods: {
    async saveDraft() {
      this.loading.saveDraft = true
      try {
        await this.save(true)
      } catch (e) {
        this.$snackbar({ message: 'Ocorreu um erro ao salvar o banner.' })
      } finally {
        this.loading.saveDraft = false
      }
    },
    async disableDraft() {
      const confirmed = await this.$confirm({
        title: 'Desativar banner',
        message: 'Tem certeza que deseja desativar o banner?',
        confirmText: 'Desativar',
        confirmColor: 'primary',
        cancelText: 'Cancelar',
      })
        .then(() => true)
        .catch(() => false)
      if (!confirmed) return
      this.loading.clone = true
      await this.$apollo
        .mutate({
          mutation: MUTATION_UNSCHEDULED_COMMERCIAL,
          variables: {
            id: this.object._id,
          },
        })
        .then(() => {
          this.redirectBanners()
        })
        .catch(() => {
          this.$snackbar(this.$t('campanhas.snackbars.errors.delete'))
        })
      this.loading.clone = false
    },
    async finalizeCommercial() {
      const confirmed = await this.$confirm({
        title: 'Finalizar banner',
        message: 'Tem certeza que deseja finalizar o banner?',
        confirmText: 'Finalizar',
        cancelText: 'Cancelar',
      })
        .then(() => true)
        .catch(() => false)
      if (!confirmed) return
      this.loading.clone = true
      await this.$apollo
        .mutate({
          mutation: MUTATION_FINALIZE_COMMERCIAL,
          variables: {
            id: this.object._id,
          },
        })
        .then(() => {
          this.redirectBanners()
        })
        .catch(() => {
          this.$snackbar(this.$t('campanhas.snackbars.errors.delete'))
        })
      this.loading.clone = false
    },
    async saveActive() {
      this.loading.saveActive = true
      try {
        await this.save(false)
      } catch (e) {
        this.$snackbar({ message: 'Ocorreu um erro ao salvar o banner.' })
      } finally {
        this.loading.saveActive = false
      }
    },
    async clone() {
      const confirmed = await this.$confirm({
        ...this.$t('campanhas.confirmations.clone'),
        message: `Deseja duplicar ${this.object.title ? 'o banner ' + this.object.title.trim().bold() : 'este banner'}?`,
      })
        .then(() => true)
        .catch(() => false)
      if (!confirmed) return
      this.loading.clone = true
      await this.$apollo
        .mutate({
          mutation: MUTATION_CLONE_COMMERCIAL,
          variables: {
            id: this.object._id,
          },
        })
        .then(
          ({
            data: {
              cloneCommercial: { _id: newId },
            },
          }) => {
            this.redirectBanners()
          }
        )
        .catch(() => {
          this.$snackbar(this.$t('campanhas.snackbars.errors.clone'))
        })
      this.loading.clone = false
    },
    async deleteCampaign() {
      const confirmed = await this.$confirm({
        title: 'Remover banner',
        message: 'Tem certeza que deseja remover o banner?',
        confirmText: 'Remover',
        confirmColor: 'vermelho-d20',
        cancelText: 'Cancelar',
      })
        .then(() => true)
        .catch(() => false)
      if (!confirmed) return
      this.loading.clone = true
      await this.$apollo
        .mutate({
          mutation: MUTATION_DELETE_COMMERCIAL,
          variables: {
            id: this.object._id,
          },
        })
        .then(() => {
          this.redirectBanners()
        })
        .catch(() => {
          this.$snackbar(this.$t('campanhas.snackbars.errors.delete'))
        })
      this.loading.clone = false
    },
    redirectBanners() {
      this.$router.push({ name: 'banners-list' }).catch(() => {})
    },
  },
}
</script>
